import type { CustomOption } from "core/catalog";
import { FileInput } from "~/design-system/components/form/FileInput";
import { CustomOptionLabel } from "./CustomOptionLabel";

type FileInputOptionProps = {
  customOption: CustomOption;
  onChange?: (value: string) => void;
};

export function FileInputOption({
  customOption,
  onChange,
}: FileInputOptionProps) {
  const handleChange = (value: string) => {
    if (onChange) {
      onChange(value);
    }
  };

  // For image type, use image accept
  const accept = customOption.type === "image" ? "image/*" : "application/pdf";

  return (
    <FileInput
      name={customOption.id}
      label={<CustomOptionLabel customOption={customOption} />}
      accept={accept}
      placeholder={customOption.description || "Upload file"}
      onChange={handleChange}
      classes={{
        wrapper: "w-full",
        label: "w-fit",
      }}
      maxFiles={3}
    />
  );
}
